"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const loading_1 = __importDefault(require("./loading"));
const sendNickName_1 = __importDefault(require("./sendNickName"));
const roomList_1 = __importDefault(require("./roomList"));
const chatWindow_1 = __importDefault(require("./talk/chatWindow"));
const modal_1 = __importDefault(require("./modal"));
const chatEvents_1 = __importDefault(require("./lib/chatEvents"));
const configureStore_1 = require("./store/configureStore");
const WebChat = (props) => {
    const { socket, config } = props;
    const { isModal, handleRoom, handleImageSize, handleSecretKey, step, handleStep } = (0, react_1.useContext)(configureStore_1.StoreContext);
    (0, react_1.useEffect)(() => {
        if (config === null || config === void 0 ? void 0 : config.imageSize)
            handleImageSize(config.imageSize);
        if (config === null || config === void 0 ? void 0 : config.secretKey)
            handleSecretKey(config.secretKey);
    }, []);
    const Events = new chatEvents_1.default(socket);
    const [rooms, setRooms] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        Events.handleConnect(() => {
            Events.getRooms(setRooms);
        });
        Events.handleDisConnect(() => {
            handleStep(1);
        });
        Events.handleError(() => {
            handleStep(1);
        });
        return () => {
            socket.close();
        };
    }, [socket]);
    (0, react_1.useEffect)(() => {
        if (rooms.length > 0) {
            if (rooms.length === 1) {
                Events.joinRoom(rooms[0]);
                handleRoom(rooms[0]);
                handleStep(5);
            }
            else {
                handleStep(3);
            }
        }
    }, [rooms]);
    return (react_1.default.createElement("article", { style: {
            display: "flex",
            flexFlow: "column wrap",
            flex: "1",
            justifyContent: "center",
            position: "relative",
            border: "1px solid #678983",
        } },
        isModal &&
            react_1.default.createElement(modal_1.default, null),
        step < 2 &&
            react_1.default.createElement(loading_1.default, { state: step }),
        step === 3 &&
            react_1.default.createElement(roomList_1.default, { rooms: rooms, socket: socket }),
        step === 4 &&
            react_1.default.createElement(sendNickName_1.default, null),
        step > 4 &&
            react_1.default.createElement(chatWindow_1.default, { socket: socket })));
};
exports.default = WebChat;
